import React from "react";
import { RCCAlert } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import {IListIncomeValue} from "./components/List/interface";
import ListTable from "./components/List";

const TableOfPerformance: React.FC<IListIncomeValue> = ({
	data,
	subsidiary,
	openChartIndicators,
	coinPlannedInitials,
	coinRealizedInitials
}) => {
	const { translate } = useTranslation();
	
	return(
		<>
			{data.length === 0 ?  (
				<RCCAlert 
					title={translate("Atenção")}
					description={translate("Não foram encontrados dados")}
				/>
			): (
				<ListTable 
					data={data}
					subsidiary={subsidiary}
					openChartIndicators={openChartIndicators}
					coinPlannedInitials={coinPlannedInitials}
					coinRealizedInitials={coinRealizedInitials}
				/>
			)}
		</>
	);};

export default TableOfPerformance;
